function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, watch, ref, computed } from "vue";
import TableList from "@/components/TableList/index.vue";
import { definePropType } from "@types-vue/props";
import { handleResourceConfig, updateViewDialog } from "../config/dialog";
import ImageContainer from "@/views/creative/components/image-container.vue";
import AudioContainer from "@/views/creative/components/audio-container.vue";
import VideoContainer from "@/views/creative/components/video-container.vue";
import { defaultCoverPreviews, handleViewProject } from "@/views/repository/resource/config/methods";
import PreviewDialog from "@/views/producer/video-template/components/preview-dialog.vue";
import { cropFont } from "@/api/common/font";
import { TabsType } from "../config/enums";
import store from "@/store";
import _ from "lodash";
export default defineComponent({
    name: "table-modular",
    components: {
        TableList: TableList,
        ImageContainer: ImageContainer,
        AudioContainer: AudioContainer,
        VideoContainer: VideoContainer,
        PreviewDialog: PreviewDialog
    },
    props: {
        resourceTable: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        checkedRow: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var viewDisabled = function viewDisabled(row) {
            if (activeTab.value === TabsType.FRAGMENT) {
                return (JSON.stringify(row.cover_previews) === "{}" || _.isNull(row.cover_previews)) && (JSON.stringify(row.previews) === "{}" || _.isNull(row.previews));
            }
            return false;
        };
        var handleResourceEditConfig = function handleResourceEditConfig(row) {
            // 片段库资源修改
            if (activeTab.value === TabsType.FRAGMENT) {
                emit("click-row", row);
            } else {
                handleResourceConfig(row, "revise");
            }
        };
        var handleViewModel = function handleViewModel(row) {
            if (row.type === TabsType.MODEL || row.type === TabsType.ACTION) {
                updateViewDialog({
                    id: row.id,
                    visible: true,
                    preview_urls: row.preview_urls,
                    name: row.name,
                    type: row.type,
                    skeleton_type: row.skeleton_type,
                    file_list: row.file_list,
                    file_meta: row.file_meta
                });
            } else if (activeTab.value === TabsType.FRAGMENT) {
                rowItem.value = row;
                dialogVisible.value = true;
            }
        };
        var dialogVisible = ref(false);
        var rowItem = ref();
        var tableListRef = ref();
        var activeTab = computed(function() {
            return store.state.resource.activeTab;
        });
        watch(function() {
            return props.checkedRow;
        }, function(val) {
            if (val.length) {
                val.forEach(function(row) {
                    // 增加计时器是为了防止缩略图切换为列表时无法默认选中的问题
                    setTimeout(function() {
                        var // @ts-ignore
                        _$ref;
                        (_$ref = tableListRef.value) === null || _$ref === void 0 ? void 0 : _$ref.toggleRowSelection(row, true);
                    }, 10);
                });
            }
        }, {
            immediate: true
        });
        watch(function() {
            return props.resourceTable.tableList;
        }, function(val) {
            if (val.length) {
                // @ts-ignore
                tableListRef.value.doLayout();
            }
        });
        var handleSelectionChange = function(val) {
            emit("handleSelection", val);
        };
        var handleSortChange = function(order) {
            emit("handleSortChange", order);
        };
        var setImgUrl = function(row) {
            var file_url = "";
            if (// 动图gif、图片
            (row.file_meta && row.file_meta.format === "gif") || row.type === 2) {
                file_url = row.file_url;
            } else if (row.thumb_url) {
                // 字体、龙骨、粒子
                file_url = row.thumb_url;
            // 片段
            } else if (row.cover_previews) {
                file_url = defaultCoverPreviews(row);
            }
            return file_url;
        };
        var cropLoading = ref({});
        var cropDataTime = ref({});
        var handleCropTest = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(item) {
                var time;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            cropLoading.value = _objectSpreadProps(_objectSpread({}, cropLoading.value), _defineProperty({}, item.id, true));
                            time = new Date().getTime();
                            _ctx.next = 5;
                            return cropFont({
                                font: item.file_meta.postscript_name || "",
                                font_url: item.file_url,
                                text: "\u5B57\u4F53\u88C1\u526A\u6D4B\u8BD5abcdefghijklmnopqrstuvwxyz" + new Date().getTime()
                            });
                        case 5:
                            cropDataTime.value = _objectSpreadProps(_objectSpread({}, cropDataTime.value), _defineProperty({}, item.id, new Date().getTime() - time));
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                            cropLoading.value = _objectSpreadProps(_objectSpread({}, cropLoading.value), _defineProperty({}, item.id, false));
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function handleCropTest(item) {
                return _ref.apply(this, arguments);
            };
        }();
        // 格式化时间
        var getTime = function(time) {
            return (time / 1000).toFixed(1);
        };
        return {
            rowItem: rowItem,
            activeTab: activeTab,
            tableListRef: tableListRef,
            cropLoading: cropLoading,
            cropDataTime: cropDataTime,
            TabsType: TabsType,
            getTime: getTime,
            setImgUrl: setImgUrl,
            viewDisabled: viewDisabled,
            handleSortChange: handleSortChange,
            handleCropTest: handleCropTest,
            dialogVisible: dialogVisible,
            handleResourceConfig: handleResourceConfig,
            handleSelectionChange: handleSelectionChange,
            handleViewModel: handleViewModel,
            handleViewProject: handleViewProject,
            handleResourceEditConfig: handleResourceEditConfig
        };
    }
});
